<template>
  <div class="skeleton-wrapper">
    <!-- Chat skeleton: alternating message bubbles -->
    <template v-if="type === 'chat'">
      <div class="skeleton-row left">
        <div class="skeleton circle"></div>
        <div class="skeleton bubble" style="width: 65%"></div>
      </div>
      <div class="skeleton-row right">
        <div class="skeleton bubble" style="width: 50%"></div>
        <div class="skeleton circle"></div>
      </div>
      <div class="skeleton-row left">
        <div class="skeleton circle"></div>
        <div class="skeleton bubble" style="width: 75%"></div>
      </div>
      <div class="skeleton-row right">
        <div class="skeleton bubble" style="width: 40%"></div>
        <div class="skeleton circle"></div>
      </div>
    </template>

    <!-- Card skeleton: stacked cards -->
    <template v-else-if="type === 'cards'">
      <div v-for="n in 3" :key="n" class="skeleton-card">
        <div class="skeleton line" style="width: 40%; height: 14px"></div>
        <div class="skeleton line" style="width: 80%; height: 12px"></div>
        <div class="skeleton line" style="width: 60%; height: 12px"></div>
      </div>
    </template>

    <!-- Profile skeleton -->
    <template v-else-if="type === 'profile'">
      <div class="skeleton-profile">
        <div class="skeleton circle large"></div>
        <div class="skeleton line" style="width: 50%; height: 16px"></div>
        <div class="skeleton line" style="width: 30%; height: 12px"></div>
      </div>
      <div v-for="n in 4" :key="n" class="skeleton-setting-row">
        <div class="skeleton line" style="width: 35%; height: 12px"></div>
        <div class="skeleton line" style="width: 55%; height: 14px"></div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "SkeletonLoader",
  props: {
    type: {
      type: String,
      default: "cards",
      validator: (v) => ["chat", "cards", "profile"].includes(v),
    },
  },
};
</script>

<style scoped>
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.skeleton {
  background: linear-gradient(90deg, var(--al-surface-sunken) 25%, var(--al-border) 50%, var(--al-surface-sunken) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: var(--al-radius-sm);
}

.skeleton.circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
}

.skeleton.circle.large {
  width: 64px;
  height: 64px;
}

.skeleton.bubble {
  height: 48px;
  border-radius: 18px;
}

.skeleton.line {
  height: 12px;
}

.skeleton-wrapper {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.skeleton-row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}

.skeleton-row.right {
  justify-content: flex-end;
}

.skeleton-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: var(--al-surface-raised);
  border-radius: var(--al-radius-lg);
  box-shadow: var(--al-shadow-sm);
}

.skeleton-profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 24px 16px;
}

.skeleton-setting-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--al-border);
}

/* Motion is for orientation, not decoration. Collapse the shimmer sweep when requested. */
@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
    background: var(--al-surface-sunken);
  }
}
</style>
